import productViewCount from "../../images/product-view-count.svg";

function ProductViewCountIcon() {
  return (
    <img
      src={productViewCount}
      alt="Product View Count"
      height={25}
      width={25}
    />
  );
}

export default ProductViewCountIcon;
